import type { FC, ReactElement } from 'react';

import { IconButton, Icons } from '../controls/iconButton/IconButton';

import styles from './Popup.module.css';

export interface PopupProps {
  content: ReactElement;
  headerLess?: boolean;
  handleClose: () => void;
}

export const Popup: FC<PopupProps> = ({ content, headerLess = false, handleClose }): ReactElement => {
  return (
    <div data-testid="popup" className={styles.popup}>
      <div
        data-testid="popup-content"
        className={`${styles.popup__content}${headerLess ? ` ${styles.popup__content_headerless}` : ''}`}
      >
        {headerLess ? null : (
          <div data-testid="popup-header" className={styles.popup__header}>
            <div data-testid="popup-close" className={styles.popup__close}>
              <IconButton icon={Icons.Close} onClick={handleClose} ghost small />
            </div>
          </div>
        )}
        {content}
      </div>
    </div>
  );
};
